<template>
  <div class="showBox">
    <div class="main-header menu-slide">
      <div class="nav-box">
          <a href="" class="logo-link" title="233乐园">
              <img src="https://webcdn.233leyuan.com/233leyuan/public/20200420/img/pc_img/logo.png" alt="233乐园" class="logo" id="logo">
          </a>
          <div class="nav-bar" id='navBarStyle'>
              <a href="/" class="nav">返回首页</a>
              <!-- <a href="http://dev.233xyx.com" class="nav">开发者平台</a>
              <a href="http://metaapp.cn" class="nav">关于我们</a> -->
              <a style="cursor: pointer;" @click="changeLaguages()" class="nav">中文/EN</a>
          </div>
      </div>
    </div>
    <swiper :options="swiperOption" ref="mySwiper" class="swiper">
      <swiper-slide class="swiper-slide wrapper-1">
        <img src="https://webcdn.233leyuan.com/233leyuan/public/20200420/img/pc_img/index/wrapper1_bg.png" class="swiper-img bg-img">
        <div class="bg-video" id="bgVideo">
            <!-- <video src="https://webcdn.233xyx.com/233leyuan/public/20200420/video/videoShow.mp4" muted="true" loop="true" autoplay="true" class="video"></video> -->
        </div>
        <div class="text-bar" :class='{"text-bar1":pageNum == 1}'>
          <h1 class="title">{{ $t('lang.page1.title')}}</h1>
          <h1 class="title secdenTitle" :class='{"enSecdenTitle":$i18n.locale == "en"}'>{{ $t('lang.page1.title1')}}</h1>
          <div class="title downloadShow">
              <div class="rightBtn">
                  <img class="ewm" id='smEwm' alt="" src='https://webcdn.233leyuan.com/233leyuan-public/000000000000/imgs/233leyuan_ewm.png'>
                  <p class="smTips">扫码下载 233乐园</p>
              </div>
              <div class="rightBtn rightBtnOnly">
                  <a class="btnDown" id='btnAndorid' target="_blank"  href='http://cdn.233yang.cn/common/share/wx/index.html' download="http://cdn.233yang.cn/common/share/wx/index.html">
                    <img v-if='enterState' @mouseenter="enterState = false" @mouseleave='enterState = true' class="btnAndorid" src='https://webcdn.233leyuan.com/233leyuan-public/000000000000/imgs/icon_andorid.png' alt="">
                    <img v-else @mouseenter="enterState = false" @mouseleave='enterState = true' class="btnAndorid" src='https://webcdn.233leyuan.com/233leyuan-public/000000000000/imgs/andorid_down.png' alt="">
                  </a>
              </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide wrapper-2">
        <img src="https://webcdn.233leyuan.com/233leyuan/public/20200420/img/pc_img/index/transition_2.png" class="swiper-img bg-img" >
        <div class="figure figure2" :class='{"bg-img1":pageNum == 2}'></div>
        <div class="text-bar" :class='{"text-bar1":pageNum == 2}'>
          <h1 class="title">{{ $t('lang.page2.title')}}</h1>
          <div class="desc">{{ $t('lang.page2.des')}}</div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide wrapper-3">
        <img src="https://webcdn.233leyuan.com/233leyuan/public/20200420/img/pc_img/index/transition_3.png" class="swiper-img bg-img">
        <div class="figure figure3" :class='{"bg-img1":pageNum == 3}'></div>
        <div class="text-bar" :class='{"text-bar1":pageNum == 3}'>
          <h1 class="title">{{ $t('lang.page3.title')}}</h1>
          <div class="desc">{{ $t('lang.page3.des')}}</div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide wrapper-4">
        <img src="https://webcdn.233leyuan.com/233leyuan/public/20200420/img/pc_img/index/transition_4.png" class="swiper-img bg-img">
        <div class="figure figure4" :class='{"bg-img1":pageNum == 4}'></div>
        <div class="text-bar" :class='{"text-bar1":pageNum == 4}'>
          <h1 class="title">{{ $t('lang.page4.title')}}</h1>
          <div class="desc">{{ $t('lang.page4.des')}}</div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide wrapper-5">
        <img src="https://webcdn.233leyuan.com/233leyuan/public/20200420/img/pc_img/index/transition_5.png" class="swiper-img bg-img">
        <div class="figure figure5" :class='{"bg-img1":pageNum == 5}'></div>
        <div class="text-bar" :class='{"text-bar1":pageNum == 5}'>
          <h1 class="title">
              {{ $t('lang.page5.title')}}
          </h1>
          <div class="desc">
              {{ $t('lang.page5.des')}}
          </div>
        </div>
        <!-- <div class="footer-bg">
          <div class="footer-box">
            <ul class="left-tlist">
                <li>
                    <p>
                        抵制不良游戏
                    </p>
                    <p>
                        适度游戏益脑
                    </p>
                </li>
                <li>
                    <p>
                        拒绝盗版游戏
                    </p>
                    <p>
                        沉迷游戏伤身
                    </p>
                </li>
                <li>
                    <p>
                        注意自我保护
                    </p>
                    <p>
                        合理安排时间
                    </p>
                </li>
                <li>
                    <p>
                        谨防受骗上当
                    </p>
                    <p>
                        享受健康生活
                    </p>
                </li>
            </ul>
            <div class="right-tcgame">
                <p>不良信息举报中心 京网文(2018)6698-541号 ICP正京B2-20181741</p>
                <p>Copyright © 2009 - 2020 233leyuan.com All Rights Reserved</p>
            </div>
          </div>
        </div> -->
      </swiper-slide>
    </swiper>
    <div class="dot-bar" id="dotBar" >
        <i class="dot" @click='getPageNum(el)' v-for='el in datList' :key='el' :class='{"dotSelected": pageNum == el,"dotNot":pageNum != el}'></i>
    </div>
    <div class="numShow">
        <p class="numBox" id='navBarStyle'>
            <i class="pageNum">0{{pageNum}}</i> 
          <i class="pagePat">/05</i>
        </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Swiper as SwiperClass,  Mousewheel, Autoplay,EffectFade } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
SwiperClass.use([ Mousewheel, Autoplay,EffectFade])
Vue.use(getAwesomeSwiper(SwiperClass))
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
import 'swiper/swiper-bundle.css'

export default {
  name: 'HelloWorld',
  data () {
    return {
      enterState:true,
      fontState:false,
      pageNum:'1',
      datList:['1','2','3','4','5'],
      swiperOption: {
        speed: 800,
        direction : 'vertical',
        // slidesPerView: 1,
        mousewheel: true,
        mousewheelControl : true,
        effect:'fade',
        on:{
          slideChange:()=>{
            let swiper = this.swiper;
            this.fontState = true;
            setTimeout(() => {
              this.pageNum = `${swiper.activeIndex + 1}`;
            }, 500);
          }
        }
      }
    }
  },
  components: {Swiper, SwiperSlide},
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
  methods:{
    changeLaguages () {
      let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = lang
    },
    getPageNum(pageNum){
      this.swiper.slideTo(pageNum-1, 1000, false)
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
/deep/.swiper-img{
  height: 100% !important;
  width: 100% !important;
}
/deep/.swiper-wrapper{
  height: 100% !important;
  width: 100% !important;
}
/deep/.swiper-slide{
  height: 100% !important;
  width: 100% !important;
}
.swiper{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
@font-face {
    font-family: 'DINAlternate-Bold, DINAlternate';
    src: url('https://webcdn.233leyuan.com/common/dinregular/1.0/DINRegular.otf');
}
 body{
    margin: 0;
    padding: 0;
    overflow: hidden;
}
a {
  text-decoration: none;
}
.showBox{
  position: relative;
  width: 100% !important;
  height: 100% !important;
}
.main-header{
  position: absolute;
  height: 90px;
  line-height: 80px;
  font-size: 16px;
  position: fixed;
  right: 0;
  left: 0;
  margin: 0 auto;
  min-width: 710px;
  width: 100%;
  z-index: 1000
}
.main-header .logo-link {
    position: absolute;
    left: 12%;
    top: 28px
}
        
.main-header .logo {
    display: block;
    width: 180px;
    height: 38px
}

.main-header .nav-box {
    position: relative;
    height: 80px;
    color: #fff;
    min-width: 900px;
}

.main-header .nav {
    display: inline-block;
    margin: 0 41px;
    color: #fff;
    font-size: 16px;
    position: relative;
    font-family: PingFangSC-Semibold, PingFang SC, microsoft yahei;
}

.main-header .nav:hover {
    opacity: 1
}

.main-header .nav-bar {
    position: absolute;
    top: 0;
    right: 10%;
    transform: translateX(0);
    opacity: 1;
    transition: all .5s ease-in-out;
}

.bg-img {
    animation: .3s scaleIn ease-in-out;
    transform-origin: 50% 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    z-index: 2;
}
.bg-img1{
  animation: 0.9s scaleIn2 cubic-bezier(0, 0.34, 0, 1.39);
  transform-origin: 100% 50%
}
.bg-video {
  height: 100%;
}

.bg-video:after {
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    z-index: 10;
}
.video {
  width: 100%;
   height: 100%;
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  object-fit: cover;
}
.figure {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: top right;
    background-size: auto 100%
}
.figure2 {
  background-image: url('https://webcdn.233leyuan.com/233leyuan-public/202008312050/imgs/picture_2.png');
  background-color: aliceblue;
}
.figure3 {
    background-image: url('https://webcdn.233leyuan.com/233leyuan-public/202008312050/imgs/picture_3.png')
}
.figure4 {
    background-image: url('https://webcdn.233leyuan.com/233leyuan-public/202008312050/imgs/picture_4.png')
}
.figure5 {
    background-image: url('https://webcdn.233leyuan.com/233leyuan-public/202008312050/imgs/picture_5.png')
}

.text-bar {
  position: absolute;
  color: #fff;
  top: 52%;
  display: none;
  left: 24%;
  text-align: left;
  z-index: 11;
}  
.text-bar1{
  display: inline-block;
  top: 52%;
  animation: .5s slideUp ease-in-out;
  transform: translateY(-50%);
}
.wrapper-1  .text-bar{
   top: 47%;
}   
.desc {
  font-size: 18px;
  line-height: 2;
  margin-top: -30px;
  height: 135px;
  width: 500px;
}
.title {
  width: 724px;
  font-size: 56px;
  position: absolute;
  top: -120px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transform: translateY(-30px)
}
.text-bar .secdenTitle {
  top: -20px;
  width: 59rem;
}
.enSecdenTitle{
   top: -37px!important;
  line-height: 80px;
}
.downloadShow {
  width: 724px;
  top: 470px !important;
  height: 203px;
}
.rightBtn {
  vertical-align: top;
  text-align: center;
  display: inline-block;
}
.ewm {
  border: 3px solid #fff;
  border-radius: 7px;
  width: 136px;
  height: 136px;
}
.smTips {
  font-size: 0.75rem !important;
  line-height: 0.0625rem !important;
}
/* 只有安卓一个下载按钮的样式 */
.rightBtnOnly {
  margin-top: 2rem !important;
}
.rightBtn:last-child {
    margin-left: 30px;
}
 .btnAndorid {
    width: 192px;
    height: 56px;
    background-size: 100% 100%;
    display: block;
}

.btnAndorid:hover {
    width: 192px;
    height: 56px;
    background-size: 100% 100%;
    display: block;
}
.dot-bar {
    position: fixed;
    width: 20px;
    top: 42%;
    left: 12%;
    transform: translateY(-30%);
    z-index: 9;
}

.dot-bar .dot {
    width: 10px;
    height: 10px;
    display: block;
    margin-bottom: 40px;
    border-radius: 100%;
    cursor: pointer;
    position: relative
}
.dot-bar .dot:after {
  top: 2px;
  left: 2px;
  width: 4px;
  height: 4px;
  border: 1px solid #fff;
  border-radius: 50%;
  transform: scale(2);
}
.dotNot{
    background-color: rgba(255, 255, 255, .5);
}
.dot-bar .dotNot:after {
  content: '';
  position: absolute;
  background-color: rgba(255, 255, 255, .5);
  transform-origin: 50% 50%;
  opacity: 0
}
.dotSelected{
  position: relative
}
.dotSelected::after {
  position: absolute;
  content: '';
  opacity: 1 !important;
  animation: scaleInDot .3s ease-in-out !important;
  background: transparent !important;
}
.numShow {
  position: fixed;
  top: 36%;
  font-size: 18px;
  color: #fff;
  width: 100%;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 9;
  font-family: 'DINAlternate-Bold, DINAlternate';
}
.numBox {
  position: absolute;
  right: 12%;
}

.numShow .pageNum {
  font-size: 72px;
  font-weight: bold;
  font-style: normal;
}
.pageNum1{
  animation: .5s slideUp ease-in-out;
}
.numShow .pagePat {
  vertical-align: top;
  margin-top: 24px;
  font-style: normal;
  display: inline-block;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.footer-bg{
  position: relative;
  background-position: center top;
  z-index: 88;
  width: 100%;
  height: 100%;
  top: 60px;
}
.footer-box {
  position: absolute;
  color: #fff;
  width: 100%;
  height: 240px;
  animation: .5s slideUp ease-in-out;
  /* top: 85%; */
  top: 85%;
  transform: translateY(-50%);
  text-align: left;
}
.footer-box a:hover {
  text-decoration: none;
  -webkit-filter: brightness(1.2);
  filter: brightness(1.2);
}
.left-tlist {
  margin-left: 12%;
}

.left-tlist li {
  width: 100px;
  height: auto;
  float: left
}
li{
  list-style:none;
}
.left-tlist li p {
  display: inline-block;
  font-size: 14px;
  color: #fff;
  line-height: 18px;
  margin-bottom: 12px;
  position: relative
}

.left-tlist li a:hover {
  color: #fff
}
.right-tcgame {
  height: 27px;
  line-height: 22px;
  text-align: right;
  top: -2px;
  margin-right: 12%;
  font-size: 12px;
  color: #fff;
  margin-top: 30px;
}
.fontTransition{
  animation: .5s slideUp ease-in-out;
}
@media (max-height: 870px) {
    .wrapper .text-bar {
        transform: translate(0, -50%) scale(0.8)
    }
}
@keyframes scaleIn2 {
  0% {
      transform: scale(1)
  }
  50% {
      transform: scale(.99)
  }
  100% {
      transform: scale(1)
  }
}
 @keyframes scaleInDot {
  0% {
      transform: scale(1)
  }
  100% {
      transform: scale(3)
  }
}       
@keyframes slideUp {
    0% {
        opacity: 0;
        margin-top: 100px
    }
    100% {
        opacity: 1;
        margin-top: 0
    }
}

@keyframes scaleIn {
    0% {
        transform: scale(1.05) translate(-50%, -50%)
    }
    100% {
        transform: scale(1) translate(-50%, -50%)
    }
}
 @media (max-height: 870px) {
  .wrapper .text-bar {
      transform: translate(0, -50%) scale(0.8)
  }
}
@media screen and (max-width: 950px) {
  .main-header .logo {
      display: block;
      width: 135px !important;
      height: 29px !important;
  }
  .main-header .logo-link {
      left: 2% !important;
  }
  .enSecdenTitle{
    top: -50px!important;
    line-height: 80px!important;
    width: 47rem !important;
  }
}
 @media screen and (max-width: 1440px) {
  .nav-box .nav-bar {
      right: 12% !important;
  }
  .main-header .logo {
      display: block;
      width: 8.4375rem !important;
      height: 1.8125rem !important;
  }
  .main-header .logo-link {
      left: 11% !important;
  }
  .main-header .nav {
      font-size: 0.85rem !important;
      font-weight: 600;
  }
 .swiper-slide .title {
      font-size: 3.75rem !important;
  }
  .wrapper-1 .title {
      font-size: 2.625rem !important;
  }
  .ewm {
      width: 6.375rem !important;
      height: 6.375rem !important;
  }
  .smTips {
      font-size: 0.75rem !important;
      line-height: 0.0625rem !important;
  }
  .btnAndorid {
      width: 9rem !important;
      height: 2.625rem !important;
  }
  /* 只有安卓一个下载按钮的样式 */
  .rightBtnOnly {
      margin-top: 2rem !important;
  }
  .rightBtn:last-child {
      margin-left: 1.5rem !important;
  }
  .numShow {
      top: 34% !important;
  }
  .numShow .pageNum {
      font-size: 3.375rem !important;
  }
  .numShow .pagePat {
      font-size: 0.875rem !important;
      margin-top: 1.125rem !important;
  }
  .text-bar .secdenTitle {
      position: absolute;
      /* top: -2.5rem !important; */
  }
.enSecdenTitle{
  top: -50px!important;
  line-height: 80px!important;
  width: 47rem!important;
}
  .downloadShow {
      top: 27.5rem !important;
  }
  .text-bar {
      top: 54% !important;
      left: 22% !important;
  }
  .wrapper-1  .text-bar{
   top: 50% !important;;
 } 
  .dot-bar {
      top: 43% !important;
  }
  .dot-bar .dot {
      width: 6px !important;
      height: 6px !important;
      margin-bottom: 30px !important;
  }
  .dot-bar .dot:after {
      content: '';
      position: absolute;
      top: 0px !important;
      left: -.5px !important;
      width: 4px !important;
      height: 4px !important;
  }
  .wrapper .desc {
      font-size: 0.875rem !important;
      margin-top: -2.1875rem !important;
  }
  .wrapper-2 .title {
      width: 50rem !important;
  }
  .wrapper-3 .title {
      width: 35rem !important;
  }
  .wrapper-4 .title {
      width: 35rem !important;
  }
  .left-tlist li {
      width: 75px !important;
  }
  .left-tlist li p {
      font-size: 0.75rem !important;
      -webkit-transform: scale(0.9);
      margin-bottom: 0.375rem;
  }
  .right-tcgame {
      font-size: 0.625rem !important;
      -webkit-transform: scale(0.8);
      line-height: 2.1rem !important;
      margin-top: -9.5px !important;
  }
}
@media screen and (max-width: 1024px) {
  .main-header .logo {
      display: block;
      width: 8.4375rem !important;
      height: 1.8125rem !important;
  }
  .main-header .logo-link {
      left: 5% !important;
  }
  .swiper-slide .title {
      font-size: 3.25rem !important;
  }
  .wrapper-1 .title {
      font-size: 2.2rem !important;
  }
  .dot-bar {
      left: 8% !important;
      top: 40% !important;
  }
  .text-bar {
      top: 45.5% !important;
      left: 20% !important;
  }
  .footer-bg .left-tlist {
      margin-left: 7%;
  }
  .footer-box .right-tcgame,
  .nav-box .nav-bar {
      right: 5.5% !important;
  }
  .left-tlist li {
      width: 5.9375rem;
  }
  .numShow {
      min-width: 64rem !important;
      top: 34% !important;
  }
  .numBox {
      position: absolute;
      right: 12% !important;
  }
  .wrapper-2 .title {
      width: 53rem !important;
  }
  .wrapper-3 .title {
      width: 40rem !important;
  }
  .wrapper-4 .title {
      width: 40rem !important;
  }
  .enSecdenTitle{
    top: -50px!important;
    line-height: 80px!important;
    width: 47rem!important;
  }
  .left-tlist li p {
      font-size: 0.6rem !important;
      -webkit-transform: scale(0.9);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/test.vue